import Vue from "vue";
import Vuex from "vuex";
import SidebarDrawerModule from "./modules/SidebarDrawerModule";
import OverlayLoaderModule from "./modules/OverlayLoaderModule";
import SelectedDrawModule from "./modules/SelectedDrawModule";
import AuthModule from "./modules/AuthModule";
import NotificationModule from "./modules/NotificationModule";
import DealerModule from "./modules/DealerModule";
import DashboardRole from "./modules/DashboardRole";
// import modules from "./modules"]
import createPersistedState from "vuex-persistedstate";
import BadgeModule from "./modules/BadgeModule";

Vue.use(Vuex);
// console.log(modules)
export default new Vuex.Store({
  modules: {
    SidebarDrawerModule,
    OverlayLoaderModule,
    SelectedDrawModule,
    auth: AuthModule,
    NotificationModule,
    DealerModule,
    DashboardRole,
    BadgeModule
  },
  // ...modules,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState()],
});
